export default {
  SET_JOIN_US: function (state, payload) {
    state.joinUsContext = payload;
  }
}
